import React, { Component } from 'react'
import { Grid, Col, Row } from 'react-flexbox-grid'
import PaidByOtherTextField from '../../../widgets/SubmitAClaim/PaidByOtherTextField'
import RBSelectField from '../../../controls/RBSelectField'
import RBButton from '../../../controls/RBButton'
import RBDatePicker from '../../../controls/RBDatePicker'
import moment from 'moment'
import { localize } from '../../../util/Localizer'
import NgrxUtil from '../../../util/NgrxUtils'
import { withStyles } from '@material-ui/core/styles'
import classnames from 'classnames'

import {
  createEmptyClaimExpense,
  createEmptyClaimExpenseError,
  convertCOBAmountForClaimExpense,
  validateClaimExpense
} from './functions'

import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

class ManageExpense extends Component {
  constructor (props) {
    super(props)

    this.updateValues = this.updateValues.bind(this)
    this.onAddExpense = this.onAddExpense.bind(this)
    this.onCancel = this.onCancel.bind(this)
    this.validate = this.validate.bind(this)

    this.state = {
      claimExpense: createEmptyClaimExpense(this.props.hasCOB),
      claimExpenseError: createEmptyClaimExpenseError()
    }

    this.state = Object.assign(this.state, ManageExpense.loadFromEdit(props, this.state))
  }

  static loadFromEdit (nextProps, state) {
    if (Object.keys(nextProps.claimExpense).length > 0 && JSON.stringify(state.claimExpense) !== JSON.stringify(nextProps.claimExpense)) {
      // we need to transform the drop down to an object when we are editing
      const claim = JSON.parse(JSON.stringify(nextProps.claimExpense))
      claim.ExtendedHealthCareLineInfo.ServiceCode = {
        id: claim.ExtendedHealthCareLineInfo.ServiceCode,
        text: claim.ExtendedHealthCareLineInfo.ServiceCodeText
      }
      // update the COB to 0 if it is a string, this is for when editing
      if (claim.COBField) {
        claim.COBField.CobAmount = claim.COBField.CobAmount.toString()
      }
      // set the state
      return {
        claimExpense: claim
      }
    }
    return null
  }

  onAddExpense () {
    if (this.validate()) {
      // locally we are using string but to send back we need to convert it an actual number
      convertCOBAmountForClaimExpense(this.state.claimExpense)

      this.props.onAddExpense(JSON.parse(JSON.stringify(this.state.claimExpense)))
      this.onCancel()
    }
  }

  onCancel () {
    this.props.onCancel()
  }

  validate () {
    const claimExpense = NgrxUtil.deepCopyObject(this.state.claimExpense)
    const claimExpenseError = NgrxUtil.deepCopyObject(this.state.claimExpenseError)
    const isValid = validateClaimExpense(claimExpense, claimExpenseError, this.props.hasCOB)

    this.setState({ claimExpenseError })

    return isValid
  }

  updateValues (valueObj) {
    // NOTE: i found this confusing to follow so I split out serviceCode to serviceCodeChanged method
    const claimExpense = { ...this.state.claimExpense }
    if (valueObj['ServiceDate']) {
      valueObj['ServiceDate'] = moment(valueObj['ServiceDate']).format('YYYY-MM-DD') // this needs to be in this format for the expenseCard
    }
    let updatedClaimExpense

    if ((valueObj['AmountPaid'] || valueObj['AmountPaid'] === '')) {
      let updatedEhcLineInfo = Object.assign({ ExtendedHealthCareLineInfo: { ...claimExpense.ExtendedHealthCareLineInfo, ...valueObj } })
      updatedClaimExpense = Object.assign(claimExpense, updatedEhcLineInfo)
    } else if (valueObj['CobAmount'] || valueObj['CobAmount'] === '') {
      const cob = Object.assign({ COBField: { ...claimExpense.COBField, ...valueObj } })
      updatedClaimExpense = Object.assign(claimExpense, cob)
    } else {
      updatedClaimExpense = Object.assign(claimExpense, valueObj)
    }

    this.setState({
      claimExpense: updatedClaimExpense,
      claimExpenseError: createEmptyClaimExpenseError()
    })
  }

  serviceCodeChanged = (args) => {
    const claimExpense = Object.assign(this.state.claimExpense)
    claimExpense.ExtendedHealthCareLineInfo.ServiceCode = {
      id: args.value,
      text: args.text
    }
    this.setState({
      claimExpense: claimExpense,
      claimExpenseError: createEmptyClaimExpenseError()
    })
  }

  renderExpense () {
    const { classes = {} } = this.props
    const { claimExpense, claimExpenseError } = { ...this.state }
    let addButtonLabel = localize('pages.SubmitAClaim.Expenses.AddExpenseButton')
    let formTitle = localize('pages.SubmitAClaim.Expenses.AddExpenseFormTitle')
    if (this.props.claimIndx >= 0) {
      addButtonLabel = localize('common.saveUpdates')
      formTitle = localize('pages.SubmitAClaim.Expenses.EditExpenseFormTitle')
    }
    return (
      <div>
        <Row start='xs'>
          <Col xs={12}>
            <h3 className='marginBottom0px'>{formTitle}</h3>
            <p className='titledLabelTitle'>{localize('error.account.activateAccount.20001018')}</p>
          </Col>
        </Row>
        <br />
        <Row start='xs'>
          <Col xs={12} >
            <RBDatePicker
              id='ServiceDate'
              label={localize('pages.SubmitAClaim.Expenses.ServiceDate')}
              errorText={claimExpenseError.ServiceDate}
              fullWidth
              pickerProps={{
                autoOk: true,
                maxDate: moment(),
                value: claimExpense.ServiceDate || null,
                onChange: value => this.updateValues({ ServiceDate: value })
              }}
            />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <RBSelectField
              data={this.props.serviceItems}
              fullWidth
              id='ServiceCode'
              label={localize('pages.SubmitAClaim.Expenses.TypeOfExpense')}
              onChanged={this.serviceCodeChanged}
              errorText={claimExpenseError.ExtendedHealthCareLineInfo.ServiceCode}
              selected={claimExpense.ExtendedHealthCareLineInfo.ServiceCode} />
          </Col>
        </Row>
        <Row start='xs'>
          <Col xs={12}>
            <PaidByOtherTextField
              textLabel={localize('pages.SubmitAClaim.Expenses.TotalChargesLabel')}
              id='AmountPaid'
              fullWidth
              autoComplete='off'
              onValueChange={this.updateValues}
              error={claimExpenseError.ExtendedHealthCareLineInfo.AmountPaid}
              value={claimExpense.ExtendedHealthCareLineInfo.AmountPaid}
              limit={10000}
            />
          </Col>
        </Row>
        {this.props.hasCOB
          ? <Row start='xs'>
            <Col xs={12}>
              <PaidByOtherTextField
                textLabel={localize('pages.SubmitAClaim.Expenses.AmountReceivedByOther')}
                id='CobAmount'
                fullWidth
                autoComplete='off'
                onValueChange={this.updateValues}
                error={claimExpenseError.COBField.CobAmount}
                value={claimExpense.COBField.CobAmount.toString()}
                labelStyles={{ width: '125%' }}
                limit={10000}
              />
            </Col>
          </Row>
          : null
        }
        <Row start='xs'>
          <Col xs={12} sm={6}>
            <RBButton fullWidth variant='outlined' label={localize('common.cancel')} onClick={this.onCancel} className={classnames(classes.margin)} />
          </Col>
          <Col xs={12} sm={6}>
            <RBButton fullWidth variant='contained' label={addButtonLabel} primary onClick={this.onAddExpense} className={classnames(classes.margin)} />
          </Col>
        </Row>
      </div>
    )
  }

  render () {
    return (
      <Grid fluid style={{ overflowY: 'scroll', height: '100vh' }}>
        {this.renderExpense()}
      </Grid>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    claimObj: state.SubmitAClaimReducer.claimObj,
    error: state.SubmitAClaimReducer.error
  }
}
const ConnectedManageExpense = connect(mapStateToProps, {})(injectIntl(ManageExpense))

const Styles = {
  margin: {
    marginTop: 10
  }
}

export default withStyles(Styles)(ConnectedManageExpense)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/ManageExpense/index.js